import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取楼盘列表
export function listBuildings(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/building.listBuildings',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve({
        data: res.buildings,
        total: res.total
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取楼盘详情
export function getBuildingDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/building.listBuildings',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加楼盘
export function saveBuilding(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/building.saveBuilding',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新楼盘
export function updateBuilding(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/building.updateBuilding',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除楼盘
export function deleteBuilding(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/building.deleteBuilding',
      method: 'post',
      data: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传图片
export function uploadImage(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/uploadFile/uploadImage',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}